export default __webpack_public_path__ + "static/media/48.b8013d08.jpeg";